module.exports = __webpack_public_path__ + "img/agency-ambassador.a7571d9b.svg";